import { useMemo } from 'react';
import { Row, TextButton, Typography } from 'seagull';
import { ArrowHead } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useResponsive } from "../../../../contexts";
import { getStepName } from "../../../ClientOnboarding.utils";
import desktopStyles from "../../OnboardingPage/Steps/StepsContainer/StepsContainerDesktop.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetHeaderTID = parentTestId => getTestIds({
  parentTestId
});
export const Header = _ref => {
  let {
    currentStep,
    relationship,
    onBack,
    testId
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  const {
    HeaderTestIds
  } = useMemo(() => GetHeaderTID(testId), [testId]);
  const stepTitle = useMemo(() => getStepName(currentStep, relationship), [currentStep, relationship]);
  if (isMobile) {
    return /*#__PURE__*/_jsx(Typography, {
      variant: "h3",
      weight: "normal",
      testId: HeaderTestIds.StepTitle(),
      children: stepTitle
    });
  }
  return /*#__PURE__*/_jsx(Row, {
    className: desktopStyles.header,
    testId: HeaderTestIds.Root(),
    children: /*#__PURE__*/_jsx(Row, {
      className: desktopStyles.headerContent,
      testId: HeaderTestIds.HeaderContent(),
      children: /*#__PURE__*/_jsx(TextButton, {
        prefixIcon: /*#__PURE__*/_jsx(ArrowHead, {
          direction: "left"
        }),
        onClick: onBack,
        skin: "secondary",
        underline: "never",
        variant: "h4",
        weight: "normal",
        testId: HeaderTestIds.BackButton(),
        children: /*#__PURE__*/_jsx("span", {
          "data-testid": HeaderTestIds.StepTitle(),
          children: stepTitle
        })
      })
    })
  });
};